function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24.25,
    height: 9.52,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 4.76,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.52,
    width: 24.25,
    height: 14.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.81875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 16.795,
    fontFamily: "Arial"
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 24.07,
    width: 24.25,
    height: 14.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.0828571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 31.36,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.64,
    width: 24.25,
    height: 18.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0850000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 47.895,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.15,
    width: 24.25,
    height: 23.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.9375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 69.025,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 80.9,
    width: 24.25,
    height: 26.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 94.25,
    fontFamily: "Arial"
  }, "\n        Montour\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.6,
    width: 24.25,
    height: 31.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 123.13999999999999,
    fontFamily: "Arial"
  }, "\n        Juniata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.68,
    width: 24.25,
    height: 32.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 155.135,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.59,
    width: 24.25,
    height: 35.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 189.3,
    fontFamily: "Arial"
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.01,
    width: 24.25,
    height: 37.4,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 225.70999999999998,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244.42,
    width: 24.25,
    height: 39.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 264.41499999999996,
    fontFamily: "Arial"
  }, "\n        Snyder\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 284.41,
    width: 24.25,
    height: 49.03,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 308.925,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333.43,
    width: 24.25,
    height: 56.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 361.595,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 389.76,
    width: 24.25,
    height: 60.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 419.935,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 450.11,
    width: 24.25,
    height: 60.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 480.385,
    fontFamily: "Arial"
  }, "\n        Mifflin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 510.67,
    width: 24.25,
    height: 62.27,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 541.8050000000001,
    fontFamily: "Arial"
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 572.93,
    width: 24.25,
    height: 63.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 604.55,
    fontFamily: "Arial"
  }, "\n        Huntingdon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 636.17,
    width: 24.25,
    height: 63.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 12.125,
    y: 668.0849999999999,
    fontFamily: "Arial"
  }, "\n        Elk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 0,
    width: 37.96,
    height: 42.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.422857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.230000000000004,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Clarion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.21,
    y: 0,
    width: 38.07,
    height: 42.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.460909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.245,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Susquehanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.28,
    y: 0,
    width: 39.65,
    height: 42.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.105,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.93,
    y: 0,
    width: 42.11,
    height: 42.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0183333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 160.985,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.04,
    y: 0,
    width: 44.01,
    height: 42.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.045,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.05,
    y: 0,
    width: 44.19,
    height: 42.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0442857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.145,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.24,
    y: 0,
    width: 46.36,
    height: 42.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.42,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.59,
    y: 0,
    width: 49.81,
    height: 42.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7011111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.495,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.4,
    y: 0,
    width: 50.45,
    height: 42.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.625,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        McKean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.85,
    y: 0,
    width: 52.93,
    height: 42.31,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.315,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.78,
    y: 0,
    width: 56.7,
    height: 42.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.28875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.13,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.48,
    y: 0,
    width: 57.44,
    height: 42.31,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.0442857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.2,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Venango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.92,
    y: 0,
    width: 58.01,
    height: 42.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.925,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Centre\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.94,
    y: 0,
    width: 58.06,
    height: 42.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.051666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.97,
    y: 21.155,
    fontFamily: "Arial"
  }, "\n        Carbon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 42.31,
    width: 62.99,
    height: 48.13,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.01625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 66.375,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 90.45,
    width: 62.99,
    height: 50.72,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2457142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 115.81,
    fontFamily: "Arial"
  }, "\n        Indiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 141.17,
    width: 62.99,
    height: 51.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 166.815,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 192.46,
    width: 62.99,
    height: 51.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.174
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 218.33,
    fontFamily: "Arial"
  }, "\n        Clearfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 244.2,
    width: 62.99,
    height: 55.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 272.025,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 299.84,
    width: 62.99,
    height: 56.06,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 327.87,
    fontFamily: "Arial"
  }, "\n        Lebanon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 355.9,
    width: 62.99,
    height: 57.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 384.565,
    fontFamily: "Arial"
  }, "\n        Somerset\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 413.23,
    width: 62.99,
    height: 67.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.498333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 447.19500000000005,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 481.15,
    width: 62.99,
    height: 68.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 515.5799999999999,
    fontFamily: "Arial"
  }, "\n        Lycoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 550.02,
    width: 62.99,
    height: 73.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.299
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 586.77,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.25,
    y: 623.52,
    width: 62.99,
    height: 76.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.87375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.745000000000005,
    y: 661.76,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 42.31,
    width: 64.97,
    height: 75.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.640714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.735,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.21,
    y: 42.31,
    width: 69.1,
    height: 75.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.516666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.76,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.31,
    y: 42.31,
    width: 72.67,
    height: 75.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.534
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 257.645,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Blair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 293.98,
    y: 42.31,
    width: 94.22,
    height: 75.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.768571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.09000000000003,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.2,
    y: 42.31,
    width: 95.44,
    height: 75.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.768571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.91999999999996,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Chester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 483.64,
    y: 42.31,
    width: 106.06,
    height: 75.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.563333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.67,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Beaver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.7,
    y: 42.31,
    width: 110.3,
    height: 75.38,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.852727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 644.85,
    y: 80,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 117.69,
    width: 94.59,
    height: 90.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.06
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 162.87,
    fontFamily: "Arial"
  }, "\n        Lehigh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 208.05,
    width: 94.59,
    height: 94.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.434999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 255.22500000000002,
    fontFamily: "Arial"
  }, "\n        Schuylkill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 302.4,
    width: 94.59,
    height: 98.49,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 23.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 351.645,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 400.89,
    width: 94.59,
    height: 99.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.459
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 450.445,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 500,
    width: 94.59,
    height: 99.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.512857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 549.915,
    fontFamily: "Arial"
  }, "\n        Cambria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.25,
    y: 599.83,
    width: 94.59,
    height: 100.17,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.6475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.54500000000002,
    y: 649.9150000000001,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.84,
    y: 117.69,
    width: 92.68,
    height: 105,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.18,
    y: 170.19,
    fontFamily: "Arial"
  }, "\n        Dauphin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.52,
    y: 117.69,
    width: 100.46,
    height: 105,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.092
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.75,
    y: 170.19,
    fontFamily: "Arial"
  }, "\n        Bucks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.98,
    y: 117.69,
    width: 100.69,
    height: 105,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.187777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 425.32500000000005,
    y: 170.19,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.67,
    y: 117.69,
    width: 101.83,
    height: 105,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.366
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.585,
    y: 170.19,
    fontFamily: "Arial"
  }, "\n        Berks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.5,
    y: 117.69,
    width: 122.5,
    height: 105,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.75,
    y: 170.19,
    fontFamily: "Arial"
  }, "\n        Lackawanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.84,
    y: 222.69,
    width: 110.03,
    height: 135.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.169166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.85500000000002,
    y: 290.47,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.84,
    y: 358.25,
    width: 110.03,
    height: 154.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.718571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.85500000000002,
    y: 435.48,
    fontFamily: "Arial"
  }, "\n        Luzerne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.84,
    y: 512.71,
    width: 110.03,
    height: 187.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.85500000000002,
    y: 606.355,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.87,
    y: 222.69,
    width: 99.46,
    height: 243.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.4325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.6,
    y: 344.37,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.33,
    y: 222.69,
    width: 308.67,
    height: 243.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.040000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.665,
    y: 344.37,
    fontFamily: "Arial"
  }, "\n        Allegheny\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.87,
    y: 466.05,
    width: 408.13,
    height: 233.95,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.495833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.935,
    y: 583.025,
    fontFamily: "Arial"
  }, "\n        Philadelphia\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.6a211ed0f56413b2663e25965d1f5777.svg";
export { ForwardRef as ReactComponent };